import { useTranslation } from "@opendash/i18n";
import { Icon } from "@opendash/icons";
import { Button, Card, Statistic } from "antd";
import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { useKanbanStates, useTicketManager } from "../../..";

export const OpenClosedTickets = observer(() => {
  const t = useTranslation();
  const [openClosedTickets, setOpenClosedTickets] = useState(0);
  const { states, outbox } = useKanbanStates();
  const [mode, setMode] = useState<boolean>(false);

  const closedTicketManager = useTicketManager();
  const otherTicketManager = useTicketManager({ filterJunction: "or" });

  useEffect(() => {
    if (!states || states.length <= 0) return;

    closedTicketManager.addFilter("state", {
      attribute: "state",
      value: outbox.id,
    });

    for (const state of states) {
      if (state.get("isFinished")) continue;

      otherTicketManager.addFilter(`state-${state.id}`, {
        attribute: "state",
        value: state.id,
      });
    }

    otherTicketManager.fetchTickets();
    closedTicketManager.fetchTickets();
  }, [states]);

  useEffect(() => {
    if (mode) {
      setOpenClosedTickets(
        (closedTicketManager.totalCount /
          (closedTicketManager.totalCount + otherTicketManager.totalCount)) *
          100
      );
    } else {
      setOpenClosedTickets(
        (otherTicketManager.totalCount /
          (closedTicketManager.totalCount + otherTicketManager.totalCount)) *
          100
      );
    }
  }, [closedTicketManager.totalCount, otherTicketManager.totalCount, mode]);

  return (
    <Card
      style={{ width: "100%" }}
      //@ts-ignore
      variant="outlined"
      actions={[
        <Button
          type="text"
          icon={<Icon icon="fa:random" />}
          onClick={() => {
            setMode((prev) => !prev);
          }}
        />,
      ]}
    >
      <Statistic
        title={
          mode
            ? t("maintenance:overview.statistics.openclosedtickets.title1")
            : t("maintenance:overview.statistics.openclosedtickets.title2")
        }
        value={openClosedTickets}
        prefix="%"
        precision={2}
      />
    </Card>
  );
});
